import { render, staticRenderFns } from "./incomedetails.vue?vue&type=template&id=39189b96&scoped=true&"
import script from "./incomedetails.vue?vue&type=script&lang=js&"
export * from "./incomedetails.vue?vue&type=script&lang=js&"
import style0 from "./incomedetails.vue?vue&type=style&index=0&id=39189b96&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39189b96",
  null
  
)

export default component.exports